import { render, staticRenderFns } from "./ExpenditureTypeSingleSelector.vue?vue&type=template&id=c4daad5a&scoped=true&"
import script from "./ExpenditureTypeSingleSelector.vue?vue&type=script&lang=js&"
export * from "./ExpenditureTypeSingleSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4daad5a",
  null
  
)

export default component.exports